export default class manualEntryDialogCtrl {
    constructor($scope, $uibModalInstance, httpRequest, logger) {
        $scope.param = {
            billId: '',
            billDate: '',
            totalTaxamt: '',
        }

        $scope.datePickerConfig = {
            minView: 'month', // 选择日期后，不会再跳转去选择时分秒
            format: 'yyyy-mm-dd',
        }
        $scope.taxIptBlur = function taxIptBlur() {
            if (+$scope.param.totalTaxamt !== +$scope.param.totalTaxamt) {
                logger.logError('税款金额必须为数字，请修改')
                return
            }
            $scope.param.totalTaxamt = (+$scope.param.totalTaxamt).toFixed(2)
        }

        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }

        $scope.ok = function ok() {
            const { billId, billDate, totalTaxamt } = $scope.param
            if (!billId) {
                logger.logError('缴款书号码为必填项，请修改')
                return
            }
            if (!billDate) {
                logger.logError('填发日期为必填项，请修改')
                return
            }
            if (!totalTaxamt) {
                logger.logError('税款金额为必填项，请修改')
                return
            }

            if (+$scope.param.totalTaxamt !== +$scope.param.totalTaxamt) {
                logger.logError('税款金额必须为数字，请修改')
                return
            }

            const layer = window.layer.msg('正在录入, 请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })

            httpRequest.post_manualInput({
                billId,
                billDate,
                totalTaxamt,
                type: '1', // 第一次默认传值1
            }).then( res => {
                const _res = res.data.value
                if (_res) {
                    // 服务器版
                    if (_res.diskType === '2') {
                        window.layer.close(layer)
                        logger.logSuccess('录入成功')
                        $uibModalInstance.close(true)
                    } else {
                        $.jsonp({
                            url: `${_res.serverAddress}/InvDk`,
                            data: {
                                SID: _res.sid,
                                SIDParam: _res.sidReqParam,
                            },
                            timeout: 86400000,
                            charset: 'GBK',
                            callbackParameter: 'callback',
                            success(json) {
                                if (json.retcode === '1') {
                                    httpRequest.post_manualInput({
                                        billId,
                                        billDate,
                                        totalTaxamt,
                                        type: '2',
                                        responseStr: json.ResponseStr,
                                    }).then(() => {
                                        window.layer.close(layer)
                                        logger.logSuccess('录入成功')
                                        $uibModalInstance.close(true)
                                    })
                                } else {
                                    window.layer.close(layer)
                                    logger.logError(json.retmsg)
                                    $uibModalInstance.close()
                                }
                            },
                            error() {
                                window.layer.close(layer)
                                logger.logError('进项服务连接失败')
                                $uibModalInstance.close()
                            },
                        })
                    }
                }
            })
        }
    }
}
manualEntryDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'logger']


// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/manualEntryDialogCtrl.js